import { Injectable } from '@angular/core';

@Injectable()
export class SharedDataService {
    showHeader = true;
    showMenu = true;
    showFooter = true;

    dealerDetails: any;
    token: string;
    vehicleDetails: any;
    showShrinkImage = false;
}

